import LanguageManager from '../language_manager/language_manager';

export default class Errors {
    static get TOO_MANY_STREAMS() {
        return {
            message: LanguageManager.get('error_571105_max_streams'),
            code: 571105
        };
    }

    static get INVALID_REPLY_FROM_THE_PLATFORM() {
        return {
            message: LanguageManager.get('error_571107_generic'),
            code: 571107
        };
    }

    static get INVALID_REPLY_FROM_ESB() {
        return {
            message: LanguageManager.get('error_571119_generic'),
            code: 571119
        };
    }

    static get MPX_TOKEN_INVALID() {
        return {
            message: LanguageManager.get('error_571106_authentication'),
            code: 571106
        };
    }

    static get GEO_BLOCK() {
        return {
            message: LanguageManager.get('error_570106_invalid_country'),
            code: 571104
        };
    }

    static get INVALID_ASSET_TYPE() {

    }

    static get TOO_MANY_STREAMS_ERROR() {
        return {
            message: LanguageManager.get('error_571123_max_streams_error'),
            code: 571123,
            title: LanguageManager.get('streams_title')
        };
    }
}



// WEBPACK FOOTER //
// ./src/modules/concurrency/errors.js